import { Task, Timestamp, WeekDays } from '@griply/types';
import { getTaskPlannedOccurrenceForDate } from '@griply/utils';
import { useMemo } from 'react';

export type UseTaskPlannedOccurrenceForDateOptions = {
  weekStartsOn: WeekDays;
  today: Timestamp;
};

export const useTaskPlannedOccurrenceForDate = (
  task: Task,
  date: Timestamp,
  { weekStartsOn, today }: UseTaskPlannedOccurrenceForDateOptions,
  enabled = true,
) =>
  useMemo(
    () =>
      enabled
        ? getTaskPlannedOccurrenceForDate(task, date, { weekStartsOn, today })
        : undefined,
    [date, task, today, weekStartsOn, enabled],
  );
